module.exports = __webpack_public_path__ + "static/14-7b20e38ebf120550d7080d9c1bc383d5.jpg";